export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return 'a9a 9a9';
    }

    birthdate() {
        return '39-19-2999';
    }
}
